export interface SubscriptionSignUpOrderSummaryBillingDateResponse {
    subscription_start_date: Date;
    subscription_minimum_contract_commitment_end_date: Date | null;
    subscription_end_date: Date;
    billing_occurance: Date[];
}